/* =========================================================================
   SAMSARA — POLISH JS (Sprint 3 Awwwards-grade microinteractions)

   Modules:
     1. Scroll progress indicator — fill copper line based on scroll position
     2. SCA counter animation — count 0→target la reveal viewport (IO observer)
     3. Number counter generic for [data-counter] elements

   Vanilla, zero deps. rAF throttled. Reduced-motion safe.
   ========================================================================= */

(function () {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* -----------------------------------------------------------------
     1. SCROLL PROGRESS INDICATOR — vertical fill copper bar
        Perf-optimized: cache docHeight, recompute doar pe resize sau
        ResizeObserver(body) (lazy images, layout shifts). Eliminate
        forced reflow per scroll event (393ms TBT saved Sprint 6 perf rescue).
     ----------------------------------------------------------------- */
  function initScrollProgress() {
    const bar = document.querySelector('[data-scroll-progress-bar]');
    if (!bar) return;

    let docHeight = 0;
    let ticking = false;

    function recalcDocHeight() {
      docHeight = document.documentElement.scrollHeight - window.innerHeight;
    }

    function update() {
      const progress = docHeight > 0 ? Math.min(100, (window.scrollY / docHeight) * 100) : 0;
      bar.style.height = progress + '%';
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    recalcDocHeight();
    update();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      recalcDocHeight();
      update();
    }, { passive: true });

    // ResizeObserver on body — recalc docHeight when content changes height
    // (lazy images loading, sections revealing, etc.). Prevents stale progress.
    if (typeof ResizeObserver !== 'undefined') {
      let roTicking = false;
      const ro = new ResizeObserver(function () {
        if (!roTicking) {
          window.requestAnimationFrame(function () {
            recalcDocHeight();
            update();
            roTicking = false;
          });
          roTicking = true;
        }
      });
      ro.observe(document.body);
    }
  }

  /* -----------------------------------------------------------------
     2. SCA COUNTER — count from 0 → target la reveal viewport
        Targets: [data-counter] cu data-counter-target="92" data-counter-duration="1500"
     ----------------------------------------------------------------- */
  function initCounters() {
    const counters = document.querySelectorAll('[data-counter]');
    if (!counters.length) return;

    if (reducedMotion || typeof IntersectionObserver === 'undefined') {
      counters.forEach(function (c) {
        c.textContent = c.dataset.counterTarget || c.textContent;
      });
      return;
    }

    function animate(el) {
      const target = parseInt(el.dataset.counterTarget, 10);
      const duration = parseInt(el.dataset.counterDuration, 10) || 1500;
      if (isNaN(target)) return;

      const start = performance.now();
      function step(now) {
        const elapsed = now - start;
        const t = Math.min(1, elapsed / duration);
        // Ease-out cubic
        const eased = 1 - Math.pow(1 - t, 3);
        el.textContent = Math.round(target * eased);
        if (t < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = target;
        }
      }
      requestAnimationFrame(step);
    }

    const observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animate(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    counters.forEach(function (c) {
      // Set initial display 0 instead of target
      const target = c.dataset.counterTarget;
      if (target) {
        c.textContent = '0';
      }
      observer.observe(c);
    });
  }

  /* -----------------------------------------------------------------
     Bootstrap
     ----------------------------------------------------------------- */
  function boot() {
    initScrollProgress();
    initCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
